import { deviceDetector } from 'shared/javascripts/util/is_mobile'
import createAndShowFlash from 'frontend/unpoly/javascripts/util/flash'
import { trackElementInteraction } from 'frontend/shared/javascripts/util/analytics'
import { isFunction } from 'lodash-es'

up.compiler('[data-share-button]', (element, data: { url: string; surveyLink?: string }) => {
  if (deviceDetector.isDesktop()) {
    up.on(element, 'click', copyUrlToClipboard)
  } else {
    up.on(element, 'click', openNativeShare)
  }

  function copyUrlToClipboard(event: Event) {
    const url = data.url || up.history.location

    navigator.clipboard
      .writeText(url)
      .then(function () {
        createAndShowFlash('success', copiedFlashText())
        trackElementInteraction(element, 'copy.link', { link: { url } })
        up.event.halt(event)
      })
      .catch(function () {
        createAndShowFlash('danger', 'Link konnte nicht kopiert werden.')
      })
  }

  function copiedFlashText(): string {
    if (!data.surveyLink) {
      return 'Link wurde in die Zwischenablage kopiert.'
    }

    return (
      'Link wurde in die Zwischenablage kopiert. Helfen Sie uns, die Teilen-Funktion noch besser ' +
      `zu machen – <a class="flashes--survey-link" href="${data.surveyLink}" target="_blank" rel="noopener">hier geht's zu einer kurzen Umfrage</a>.`
    )
  }

  function openNativeShare(event: MouseEvent) {
    if (isFunction(navigator.share)) {
      void navigator.share(data)
      // Only the link: `data` also holds the sheet's title and text, and for a learning plan those
      // contain the name its owner typed.
      trackElementInteraction(element, 'click.nativeShare', { nativeShare: { url: data.url } })
      up.event.halt(event)
    } else {
      copyUrlToClipboard(event)
    }
  }
})
